import PropTypes from 'prop-types';
import React from 'react';
import Carousel from 'nuka-carousel';
import { Image } from 'react-bootstrap';
import './PhotoSwipeThumbnails.scss';

class PhotoSwipeThumbnails extends React.Component {
	// eslint-disable-next-line
	UNSAFE_componentWillReceiveProps(nextProps) {
		if (
			this.thumbnailSlider &&
			nextProps.currentIndex !== this.props.currentIndex
		) {
			this.thumbnailSlider.goToSlide(
				this.getCurrentMiddleIndex(nextProps)
			);
		}
	}

	/**
	 * method uses the viewport and number of slides to display in order to have the currently viewed image centered
	 * when there are enough images on either side,. or left or right aligned when its' towards the beginning or end of
	 * the images array
	 * @param props {optional} - viewportWidth, items, currentIndex. Uses this.props if not supplied.
	 * @returns index that should be centered in the thumbnail display
	 */
	getCurrentMiddleIndex(props) {
		const slidesToShow = this.getSlidesToShow(props);
		const { images, currentIndex } = props || this.props;

		const halfOfVisibleSlides = Math.round(slidesToShow / 2);

		let slideToBeCentered = currentIndex;
		if (slideToBeCentered < halfOfVisibleSlides) {
			const shouldStartSlidingIndex = halfOfVisibleSlides;
			if (slideToBeCentered < shouldStartSlidingIndex) {
				slideToBeCentered = shouldStartSlidingIndex;
			}
		} else {
			// -1 because we're looking for index, not length
			const shouldStopSlidingIndex =
				images.length - 1 - halfOfVisibleSlides;
			if (slideToBeCentered > shouldStopSlidingIndex) {
				slideToBeCentered = shouldStopSlidingIndex;
			}
		}

		return slideToBeCentered;
	}

	getSlidesToShow(props) {
		const { viewportWidth } = props || this.props;

		// 244 gap leaves a 2 slide positioning difference.
		return parseInt((viewportWidth - 244) / 114, 10);
	}

	render() {
		const decorators = [];
		const slidesToShow = this.getSlidesToShow();
		const {
			currentIndex,
			images,
			isDesktop,
			viewportWidth,
			trackGa,
			goToPhoto,
			updateIsBeingDragged
		} = this.props;
		// plus 1 so we only care when we have a slide off screen
		const halfOfSlidesToShow = parseInt(slidesToShow / 2, 10) + 1;
		if (currentIndex > halfOfSlidesToShow) {
			decorators.push({
				component: () => (
					<div type="previous" className="fader fade-right" />
				),
				position: 'CenterLeft'
			});
		}
		// - 1 to adjust for length vs index
		if (currentIndex < images.length - 1 - halfOfSlidesToShow) {
			decorators.push({
				component: () => (
					<div type="next" className="fader fade-left" />
				),
				position: 'CenterRight'
			});
		}

		const sliderProps = {
			decorators,
			cellSpacing: 4,
			swiping: !isDesktop,
			dragging: false,
			cellAlign: 'center',
			wrapAround: false,
			speed: 250,
			slidesToShow: this.getSlidesToShow(),
			slideIndex: this.getCurrentMiddleIndex(),
			width: `${viewportWidth}px`,
			withoutControls: true,
			slideWidth: '114px',
			ref: (cmp) => {
				this.thumbnailSlider = cmp;
			}
		};
		return (
			<div className="pswp-thumbnails fixed-bottom pt-2 pb-2 bg-black">
				<Carousel {...sliderProps}>
					{images.map((image, index) => {
						return (
							<Image
								alt=""
								key={`pswp-thumb-${image.thumbnail}`}
								className={`pswp-thumbnail ws-vehicle-media-thumbnail ${
									index === this.props.currentIndex
										? 'active'
										: ''
								}`}
								src={image.thumbnail}
								width={106}
								height={80}
								onClick={(e) => {
									goToPhoto(index, e);
									updateIsBeingDragged(false);
									trackGa({
										element: 'Thumbnail Carousel',
										result: 'Photo comes into view',
										widgetState: 'Gallery Modal',
										dataToExcludeFromWidgetUserEvent: {
											currentItem: currentIndex + 1,
											totalItems: images.length
										}
									});
								}}
								onLoad={() => {
									// Fire a resize event to force a redraw of the carousel so it can recalculate the height
									if (index === 0) {
										window.dispatchEvent(
											new Event('resize')
										);
									}
								}}
							/>
						);
					})}
				</Carousel>
			</div>
		);
	}
}

PhotoSwipeThumbnails.defaultProps = {
	updateIsBeingDragged: () => {}
};

PhotoSwipeThumbnails.propTypes = {
	currentIndex: PropTypes.number.isRequired,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string,
			thumbnail: PropTypes.string
		})
	).isRequired,
	trackGa: PropTypes.func.isRequired,
	goToPhoto: PropTypes.func.isRequired,
	viewportWidth: PropTypes.number.isRequired,
	isDesktop: PropTypes.bool.isRequired,
	updateIsBeingDragged: PropTypes.func
};

export default PhotoSwipeThumbnails;
